var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration-g-email-success-grayscale"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-1754",
    d: "M114.157 12C133.325 32.7236 150.731 55.0844 166.124 78.759C168.562 82.5097 170.986 86.3739 172.093 90.7104C173.451 96.0258 172.729 101.625 172 107.062C169.212 127.842 166.424 148.623 163.636 169.403C163.279 172.066 162.833 174.918 160.981 176.861C158.202 179.776 153.551 179.45 149.565 178.907C123.913 175.413 98.2623 171.92 72.6112 168.426C62.3509 167.028 52.0907 165.631 41.8295 164.233C36.7065 163.536 31.5664 162.916 26.4557 162.138C22.9849 161.61 18.7465 161.319 16.4783 158.219C14.6196 155.68 14.9024 152.212 15.268 149.084C18.1018 124.829 20.9357 100.575 23.7695 76.3203C24.1076 73.4265 24.4875 70.4124 26.0891 67.9803C27.3946 65.9976 29.3896 64.5941 31.3416 63.246C58.064 44.7904 85.7119 27.681 114.157 12Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1753",
    d: "M171.55 92.8335C146.424 105.754 120.27 116.412 93.3797 124.37C86.8322 126.335 80.817 117.443 76.0644 112.681L60.6764 97.4295L27.6074 65.0265L171.55 92.8335Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1752",
    d: "M112.292 119.241L159.682 178.252L112.292 119.241Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1751",
    d: "M128.211 49.6078L134.06 66.4252C145.396 63.0619 157.387 66.2582 165.533 74.7508L128.211 49.6078Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1750",
    d: "M159.682 95.6641C162.146 90.3363 163.936 84.8415 164.999 79.1797C166.063 73.3185 164.635 67.4907 161.277 62.6953C158.29 59.332 154.567 56.6681 150.314 55.2694C143.064 52.6054 135.451 50.6734 127.847 49.4082L49.3415 34.189C47.2142 49.7746 44.9203 65.3592 42.7939 80.7778L159.682 95.6641Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1749",
    d: "M161.978 96.5631C164.273 91.2352 161.978 84.5077 162.678 78.8469C163.369 73.1851 163.209 68.5567 159.682 63.9607C157.227 60.5974 153.664 58.0995 149.782 56.8677C142.532 54.0368 135.824 48.9084 128.211 47.4763C102.054 42.3479 75.8639 40.2164 49.7071 35.0546C47.5798 50.6402 44.9212 65.1925 42.7939 80.7781L161.978 96.5631Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector-1475",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4725 62.3203C86.6952 57.5671 92.2654 53.3314 98.1222 49.6597C99.7011 48.4466 101.476 47.6032 103.344 47.1786C105.478 46.982 107.614 47.5346 109.463 48.7621C109.463 48.7621 109.538 48.7624 109.558 48.835C110.056 49.1149 110.544 49.4311 111.031 49.7594C116.325 53.4063 120.987 58.7428 122.948 65.4464C123.301 66.6782 123.566 67.9403 123.741 69.2205C124.207 72.9203 123.987 76.6908 123.095 80.289C121.844 85.1456 119.699 89.6443 116.804 93.4864C113.417 98.3474 108.847 101.965 103.666 103.889C101.643 104.584 99.5438 104.95 97.4308 104.976C91.061 105.047 84.627 102.387 78.9817 98.8594C77.8894 98.1946 76.829 97.4642 75.805 96.6712C73.9238 95.3101 72.2756 93.5713 70.9405 91.5394C64.609 81.1804 74.8353 68.7239 81.4725 62.3203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1474",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1835 51.4257C101.776 49.9801 108.819 51.9696 114.068 56.2691C116.191 58.0077 118.028 60.128 119.414 62.5353C122.501 67.8926 123.491 74.3881 122.735 80.5715C121.979 86.7548 119.555 92.6404 116.268 97.8692C113.75 101.875 110.666 105.582 106.792 108.194C102.919 110.805 98.1924 112.253 93.6133 111.57C89.6424 110.978 86.0159 108.843 82.9371 106.189C76.1353 100.323 71.6538 91.7135 70.5116 82.6414C69.623 75.5828 70.8361 67.9887 75.1059 62.4008C79.827 56.2223 87.3837 53.3996 94.5438 51.577C94.7566 51.5229 94.9694 51.4725 95.1835 51.4257Z",
    fill: "#2CBA94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1473",
    d: "M103.684 76.1086C107.175 71.0881 113.284 69.2352 115.902 68.9364C122.884 70.7295 105.429 92.2461 94.9567 99.4184C84.4843 106.591 76.6301 93.1427 75.7574 84.1774C74.8847 75.2121 87.1026 83.2808 88.848 89.5565C90.5934 95.8322 99.3205 82.3843 103.684 76.1086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1472",
    d: "M77.2405 86.9737C72.4203 78.196 84.27 82.2713 87.5336 86.9737C90.7973 91.6761 88.588 93.0346 92.8057 89.0637C98.0778 84.1002 113.894 65.2911 116.154 69.9932C118.413 74.6953 92.8057 97.1619 90.5462 98.2071C88.2868 99.2523 82.0607 95.7514 77.2405 86.9737Z",
    stroke: "#393B46",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1471",
    d: "M94.0832 53.6399C78.2044 54.0253 65.6347 67.6263 66.0081 84.0175C66.3687 99.8673 78.7302 112.627 94.0843 113C109.964 113 126 96.3878 126 80.0542C125.986 64.992 111.497 53.6399 94.0832 53.6399Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vector-1748",
    d: "M103.481 22.8235C103.135 23.4923 102.955 24.2337 103.01 24.9922C103.101 26.2698 103.813 27.4137 104.575 28.4423C107.82 32.816 112.285 36.0867 116.442 39.6017C137.965 57.8064 152.528 85.6401 150.121 113.759C148.266 135.439 136.969 154.959 129.078 175.23C135.613 178.309 142.819 179.948 150.04 179.999C152.562 180.016 155.152 179.827 157.444 178.775C162.813 176.31 162.466 171.126 162.746 166.107C163.091 159.925 163.816 153.77 164.769 147.654C166.685 135.356 169.516 123.227 172.084 111.055C173.163 105.941 174.198 100.817 175.1 95.6689C175.388 94.0297 175.652 92.2932 175.053 90.7427C174.453 89.1932 173.093 88.0931 171.825 87.0197C151.95 70.1919 142.681 43.3571 122.898 26.4176C119.609 23.6011 115.931 21.0316 111.704 20.1061C109.815 19.693 107.774 19.6357 106.015 20.4401C104.947 20.9267 104.016 21.7892 103.481 22.8235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1747",
    d: "M67.7539 33.9888C81.1813 25.2967 100.657 21.068 114.084 12.376C126.447 25.6631 144.492 42.8469 155.101 57.5661",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1745",
    d: "M128.211 49.6078C130.17 55.2696 132.102 61.2967 134.06 66.9576C145.192 63.4273 157.387 66.5912 165.533 74.9169",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1744",
    d: "M158.451 95.131C160.747 90.0026 162.341 84.5078 163.237 79.013C163.936 73.3513 163.936 68.0234 160.418 63.4274C157.591 59.8972 153.7 58.632 149.614 57.0338C142.365 54.0369 135.824 48.5421 128.21 47.11C102.052 41.9816 75.8621 40.5495 49.7053 35.588C47.578 51.1736 45.6507 65.7259 43.5234 81.1111",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1743",
    d: "M167.996 72.8188C170.451 76.7154 174.705 88.0714 177 91.9671C173.278 118.708 169.06 145.483 165.336 172.224C164.636 177.02 158.787 177.02 154.001 176.287C110.165 170.26 66.158 166.363 22.4535 160.336C17.8667 159.636 15.7403 156.606 16.4374 152.01C19.9606 124.003 22.8183 95.4964 26.7081 67.8564C33.787 63.2604 39.2708 57.3992 46.3497 52.6038",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1742",
    d: "M171.019 92.134C146.087 105.055 119.738 114.646 92.6807 122.606C86.1332 124.57 80.4827 117.81 75.6968 113.047C70.5786 108.086 64.8957 103.656 59.7774 98.5276C48.8097 87.539 39.9187 77.0875 28.752 66.2639",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1741",
    d: "M112.487 119.042C128.246 138.723 142.856 157.013 158.783 176.695",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector-1740",
    d: "M17.8701 157.314C37.3137 142.428 56.423 127.367 75.8646 112.681",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email-success.26566ab68e94b956ef292c1113faa4d2.svg";
export { ForwardRef as ReactComponent };